// Breached-password check (docs/architecture.md §9b) using Have I Been Pwned's range API with
// k-anonymity: only the first 5 characters of the password's SHA-1 leave the browser, never the
// password. Cognito Plus also blocks compromised passwords server-side on password set/change.

export async function isBreached(password: string): Promise<boolean> {
  try {
    const digest = await crypto.subtle.digest('SHA-1', new TextEncoder().encode(password));
    const hex = Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, '0'))
      .join('')
      .toUpperCase();
    const res = await fetch(`https://api.pwnedpasswords.com/range/${hex.slice(0, 5)}`, {
      headers: { 'Add-Padding': 'true' },
    });
    if (!res.ok) return false;
    const suffix = hex.slice(5);
    return (await res.text())
      .split('\n')
      .some((line) => line.startsWith(suffix) && Number(line.split(':')[1]) > 0);
  } catch {
    // The service is unavailable: don't block the user; Cognito still checks server-side.
    return false;
  }
}
